import { NotificationHubButton } from '@Components/Navigation/NotificationHub/NotificationHubButton';
import { FlexRow, Header } from '@synqo/frontend-component-library';
import { BrandLogo } from './BrandLogo';

export function SynqoHeader() {
    return (
        <FlexRow justify="space-between" align="center" maximize>
            <Header logo={BrandLogo} />
            <NotificationHubButton />
        </FlexRow>
    );
}
